/**
 * Canonical event-name constants for the F27 Results page redesign.
 *
 * Phase 2B.1: names only — no fire sites wired yet (apart from the
 * ShoppingRow tap, which was already added in Phase 1, and the
 * NearbyStoresSheet scaffold). Subsequent phases fire these from the new
 * card components as the visual rewrite lands.
 *
 * Using a typed constant map (rather than scattering string literals) keeps
 * event names greppable and prevents typos between fire site and analytics
 * dashboard filters.
 */

export const RESULTS_ANALYTICS_EVENTS = {
  // Top nav
  TOP_NAV_BACK_TAPPED: "results_top_nav_back_tapped",
  BOOKMARK_TAPPED: "results_bookmark_tapped",

  // Reference + look images
  REFERENCE_IMAGE_VIEWED: "results_reference_image_viewed",
  LB1_IMAGE_VIEWED: "results_lb1_image_viewed",
  LB2_IMAGE_VIEWED: "results_lb2_image_viewed",
  LB3_IMAGE_VIEWED: "results_lb3_image_viewed",

  // Look actions
  LB1_SHARED: "results_lb1_shared",
  LB1_DOWNLOADED: "results_lb1_downloaded",
  LB1_REGENERATED: "results_lb1_regenerated",
  LB2_SHARED: "results_lb2_shared",
  LB2_DOWNLOADED: "results_lb2_downloaded",
  LB3_SHARED: "results_lb3_shared",
  LB3_DOWNLOADED: "results_lb3_downloaded",

  // LB3 state-specific CTAs
  LB3_GUEST_CTA_TAPPED: "results_lb3_guest_cta_tapped",
  LB3_ADD_WARDROBE_TAPPED: "results_lb3_add_wardrobe_tapped",

  // Shopping
  SHOPPING_ROW_TAPPED: "results_shopping_row_tapped",
  SHOPPING_THUMBNAIL_TAPPED: "results_shopping_thumbnail_tapped",
  FIND_CHEAPER_TAPPED: "results_find_cheaper_tapped",

  // Global Find Nearby toggle (Phase 2B.5b — replaces per-item flow)
  FIND_NEARBY_GLOBAL_TAPPED: "results_find_nearby_global_tapped",
  FIND_NEARBY_GLOBAL_RESULTS_RETURNED: "results_find_nearby_global_results_returned",
  FIND_NEARBY_GLOBAL_NO_RESULTS: "results_find_nearby_global_no_results",
  FIND_NEARBY_GLOBAL_PERMISSION_DENIED: "results_find_nearby_global_permission_denied",
  FIND_NEARBY_TOGGLE_BACK_TO_ONLINE: "results_find_nearby_toggle_back_to_online",
} as const;

export type ResultsAnalyticsEvent =
  (typeof RESULTS_ANALYTICS_EVENTS)[keyof typeof RESULTS_ANALYTICS_EVENTS];
